import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Camera } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-16 md:pt-48 md:pb-24 overflow-hidden" data-id="element-149">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-150">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-151">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-2 lg:order-1 text-center lg:text-left" data-id="element-152">
            <div className="inline-flex items-center space-x-2 text-warm-brown font-medium tracking-wider uppercase text-sm mb-6" data-id="element-153">
              <span className="w-8 h-px bg-warm-brown" data-id="element-154"></span>
              <span data-id="element-155">Paducah, Kentucky</span>
              <span className="w-8 h-px bg-warm-brown" data-id="element-156"></span>
            </div>

            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-charcoal leading-tight mb-6" data-id="element-157">
              Asian Fusion <br data-id="element-158" />
              <span className="text-warm-brown italic" data-id="element-159">Reimagined.</span>
            </h2>

            <p className="text-lg text-gray-600 mb-8 max-w-lg mx-auto lg:mx-0 leading-relaxed" data-id="element-160">
              Experience bold flavors and elegant presentation in the heart of
              downtown Paducah. A culinary journey where East meets West.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-161">
              <a href="#menu" className="bg-warm-brown text-white px-8 py-4 font-medium tracking-wide uppercase text-sm hover:bg-dark-brick transition-colors w-full sm:w-auto text-center" data-id="element-162">
                View Menu
              </a>
              <div className="flex items-center space-x-4 text-sm text-gray-500 font-medium" data-id="element-163">
                <div className="flex items-center" data-id="element-164">
                  <Clock size={16} className="mr-2 text-amber" data-id="element-165" />
                  <span data-id="element-166">Open Today 11am - 10pm</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Building Photo Placeholder */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="order-1 lg:order-2 relative" data-id="element-167">
            <div className="aspect-[4/5] md:aspect-square lg:aspect-[4/5] w-full relative group rounded-sm overflow-hidden shadow-2xl" data-id="element-168">
              <img src="https://cdn.magicpatterns.com/uploads/waCvpSWZ8tFXQ3hePcsRbT/IMG_20260420_093807.jpg" alt="Freddie Cheah Restaurant Front" className="absolute inset-0 w-full h-full object-cover object-center z-10 transition-transform duration-700 group-hover:scale-105" data-id="element-169" />

              {/* Decorative Frame */}
              <div className="absolute inset-4 border border-white/20 z-20 pointer-events-none" data-id="element-170"></div>

              {/* Subtle overlay effect */}
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors duration-500 z-30 pointer-events-none" data-id="element-171"></div>
            </div>

            {/* Decorative background element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-amber/10 rounded-full blur-3xl -z-10" data-id="element-172"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}